import { Link } from "react-router-dom";
import { useDictionary } from "../../contexts/dictionary";
import { VImage } from "../../style/base.style";
import { blog_11 } from "../../constants/images";
import { articles } from "../../assets/constant/articles";

export const ArticlesSection = () => {

    const {translate} = useDictionary()

    return (
        <section className="articles-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 aos" data-aos="fade-up">
              <div className="section-header-one text-center">
                <h2 className="section-title">{translate('latest_articles')}</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {
                articles.map((article, index) => 
                    (
                        <div className="col-lg-6 col-md-6 d-flex aos" data-aos="fade-up" key={index}>
                        <div className="articles-grid w-100">
                          <div className="articles-info">
                            <div className="articles-left">
                              <Link to={`articles/${article.id}`}>
                                <div className="articles-img">
                                  <VImage
                                    src={article.img}
                                    className="img-fluid"
                                    alt="1John Doe"
                                  />
                                </div>
                              </Link>
                            </div>
                            <div className="articles-right">
                              <div className="articles-content">
                                <ul className="articles-list nav">
                                  
                                  <li>
                                    <i className="feather icon-calendar" /> {new Date(article.createdOn).toLocaleDateString()}
                                  </li>
                                </ul>
                                <h4>
                                  <Link to={`articles/${article.id}`}>
                                    {translate(article.title)}
                                  </Link>
                                </h4>
                                <p>
                                  {translate(article.Paragraphs[0].content).split(" ").slice(0, 15).join(" ")}
                                </p>
                                <Link to={`articles/${article.id}`} className="btn btn-primary">
                                    {translate('read_more')}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>       
                    )

                )
            }
            
           
          </div>
        </div>
      </section>
    )
};